import BaseAPIService from '../base/base-api-service';
import PowerUserModel from 'src/model/powerUser.model';
import env from 'src/shared/env';

class PowerUserService extends BaseAPIService<PowerUserModel> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = '/accountapp/v1';

  constructor() {
    super(PowerUserModel);
  }

  public searchPowerUsers(search: string): Promise<PowerUserModel[]> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        search
      },
      url: `${this.endpoint}/poweruser`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public addPowerUser(
    email: string,
    fullName: string,
    handlerId: number,
    mobileNumber: string,
    password: string,
    username: string
  ): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'POST',
      data: {
        email,
        fullName,
        handlerId,
        mobileNumber,
        password,
        username
      },
      url: `${this.endpoint}/poweruser`
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        throw error;
      });
  }

  public deletePowerUser(id: number): Promise<string> {
    return this.doRequest({
      method: 'DELETE',
      baseURL: this.baseURL,
      url: `${this.endpoint}/poweruser/${id}`
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  }
}

const powerUserServiceInstance = new PowerUserService();
Object.freeze(powerUserServiceInstance);

export default powerUserServiceInstance;
